/**
 * UEFA Nations League - competition rule, every season.
 *
 * Identity: API-Football league.id = 5.
 */

import { UEFA_NATIONS_LEAGUE_BRACKET } from '../brackets/uefaNationsLeagueBracket';
import type { CompetitionRule } from '../types';

const rule: CompetitionRule = {
  leagueCode: '5',
  tieBracket: UEFA_NATIONS_LEAGUE_BRACKET,
};

export default rule;
